const NetInfo: any = {
  addEventListener: (callback: (state: any) => void) => {
    const handler = () => callback({ isConnected: navigator.onLine, type: 'wifi' });
    window.addEventListener('online', handler);
    window.addEventListener('offline', handler);
    // 立即回调一次
    handler();
    return () => {
      window.removeEventListener('online', handler);
      window.removeEventListener('offline', handler);
    };
  },
  fetch: async () => ({ isConnected: navigator.onLine, type: 'wifi' }),
};

export default NetInfo;
export const fetch = NetInfo.fetch;

